/**
 * Home Assessment Dashboard: pin a project as the default, from the dropdown.
 *
 * Each row of the project Select2 list gets a pin icon. Clicking it saves that
 * project (user meta, includes/home-dashboard-pinned-project.php) without
 * selecting the row, so the next /home load selects it; clicking the pinned
 * row's icon clears the pin. The pinned project is listed first (server-side,
 * and re-sorted here after a change); the closed dropdown shows the pin too when
 * the selected project is the pinned one.
 *
 * Select2 on .project-selection is initialised by the dashboard bundle (the
 * year files' shared formatState template) and re-initialised by
 * home-dashboard-dispatch.js, which also runs .off('change') on the select.
 * So this file doesn't init Select2 or bind to the element: it sets the live
 * instance's templateResult / templateSelection before every open (a
 * delegated select2:opening handler, which the dispatch's .off() can't remove).
 */
(function ($) {
    'use strict';

    var SELECT = '.home-project-dashboard-widget .project-selection';

    $(function () {
        var $controls = $('.home-project-dashboard-widget .home-project-dashboard-controls');
        if (!$controls.length || !$(SELECT).length) {
            return;
        }

        var ajaxUrl = $controls.data('pin-ajax-url');
        var nonce = $controls.data('pin-nonce');
        var pinnedId = parseInt($controls.data('pinned-project-id'), 10) || 0;

        function postIdOf(element) {
            return parseInt($(element).data('post-id'), 10) || 0;
        }

        function pinIcon(postId) {
            var isPinned = postId === pinnedId;
            return $('<span class="home-project-pin" role="button"></span>')
                .toggleClass('is-pinned', isPinned)
                .attr('data-post-id', postId)
                .attr('title', isPinned ? 'Unpin: stop loading this project by default' : 'Pin: load this project by default')
                .attr('aria-label', isPinned ? 'Unpin project' : 'Pin project')
                .attr('aria-pressed', isPinned ? 'true' : 'false')
                .append('<i class="fas fa-thumbtack" aria-hidden="true"></i>')
                // Select2 (4.1) selects a row on click, delegated on the results
                // list, which is below document; so these go on the icon itself.
                // Stopping here keeps the row unselected and the list open.
                .on('mousedown mouseup', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                })
                .on('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    savePin(postId === pinnedId ? 0 : postId);
                });
        }

        function templateResult(state) {
            var postId = state.element ? postIdOf(state.element) : 0;
            if (!state.id || !postId) {
                return state.text;
            }
            return $('<span class="home-project-option"></span>')
                .append($('<span class="home-project-option-title"></span>').text(state.text))
                .append(pinIcon(postId));
        }

        function templateSelection(state) {
            var postId = state.element ? postIdOf(state.element) : 0;
            if (!postId || postId !== pinnedId) {
                return state.text;
            }
            return $('<span class="home-project-selection"></span>')
                .append('<i class="fas fa-thumbtack home-project-selection-pin" aria-hidden="true" title="Pinned: loads by default"></i>')
                .append($('<span></span>').text(state.text));
        }

        // Point the live Select2 instance at our templates. Select2 reads them at
        // render time, so no destroy / re-init (and no lost handlers) is needed.
        function applyTemplates() {
            var inst = $(SELECT).data('select2');
            if (!inst || !inst.options) {
                return false;
            }
            inst.options.set('templateResult', templateResult);
            inst.options.set('templateSelection', templateSelection);
            return true;
        }

        function refreshSelection() {
            if (applyTemplates()) {
                $(SELECT).trigger('change.select2');
            }
        }

        // Re-render pin icons in an open list without closing it.
        function refreshOpenIcons() {
            $('.select2-container--open .home-project-pin').each(function () {
                var $old = $(this);
                $old.replaceWith(pinIcon(parseInt($old.attr('data-post-id'), 10) || 0));
            });
        }

        // Pinned project first, the rest alphabetical (data-alpha-order from the
        // server), matching what the next page load renders. home-dashboard.js
        // selects the first project on load, so the server's order is what makes
        // the pin the default; this keeps the open page in step. The selection
        // itself doesn't change.
        function syncOptions() {
            var $select = $(SELECT);
            var $projects = $select.find('option').filter(function () {
                return postIdOf(this) > 0;
            });
            $projects.each(function () {
                if (postIdOf(this) === pinnedId) {
                    $(this).attr('data-pinned', '1');
                } else {
                    $(this).removeAttr('data-pinned');
                }
            });
            var sorted = $projects.get().sort(function (a, b) {
                var pa = postIdOf(a) === pinnedId ? 0 : 1;
                var pb = postIdOf(b) === pinnedId ? 0 : 1;
                return pa - pb || (parseInt($(a).data('alpha-order'), 10) - parseInt($(b).data('alpha-order'), 10));
            });
            // Moving the selected <option> makes the browser re-pick a selection,
            // so put it back (without 'change': the charts shouldn't reload).
            var current = $select.val();
            $select.append(sorted);
            $select.val(current);
        }

        function savePin(target) {
            var previous = pinnedId;
            pinnedId = target;
            syncOptions();
            refreshOpenIcons();
            refreshSelection();

            $.post(ajaxUrl, { action: 'crf_pin_home_project', nonce: nonce, project_id: target })
                .done(function (res) {
                    if (res && res.success) {
                        pinnedId = parseInt(res.data.pinned_project_id, 10) || 0;
                    } else {
                        pinnedId = previous;
                        window.alert((res && res.data && res.data.message) || 'Could not save the pinned project.');
                    }
                })
                .fail(function (xhr) {
                    pinnedId = previous;
                    var msg = xhr.responseJSON && xhr.responseJSON.data && xhr.responseJSON.data.message;
                    window.alert(msg || 'Could not save the pinned project.');
                })
                .always(function () {
                    syncOptions();
                    refreshOpenIcons();
                    refreshSelection();
                });
        }

        $(document).on('select2:opening', SELECT, applyTemplates);

        // After the bundle's init and home-dashboard-dispatch.js's re-init
        // (queued with setTimeout(0) from earlier ready callbacks).
        window.setTimeout(refreshSelection, 0);
    });
})(jQuery);
